import { ComponentStyleConfig } from '@chakra-ui/react';

const Switch: ComponentStyleConfig = {
  defaultProps: {
    colorScheme: 'switch',
  },
};

export default Switch;
